<app-header></app-header>
<main class="timeapp" style="display: flex; flex-direction: column;">
	<div class="flex-row" style="    width: 100%;    justify-content: center;    align-items: center;    padding: 0.5em 0;    display: flex;">
		<fa-icon (click)="previous()" [icon]="faAngleLeft" style="color: black"></fa-icon>
		<mat-form-field appearance="outline" style="margin: 0.75rem 1.5rem 0 1.5rem; width: auto;">
			<mat-label>{{ "TIMEENTRY.Datum" | translate }}</mat-label>
			<input [formControl]="formValue" [matDatepicker]="picker" matInput/>
			<mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
			<mat-datepicker #picker [dateClass]="dateClass()"></mat-datepicker>
		</mat-form-field>
		<fa-icon (click)="next()" [icon]="faAngleRight" style="color: black"></fa-icon>
	</div>
	
	<div style="width: 100%; flex: 1; overflow: auto">
		<div *ngFor="let item of filteredEmpWorkPlan;" class="item">
			<mat-divider></mat-divider>
			<div (click)="choosedOrder(item)" class="data">
				<div> {{ item.objectNumber + " " + item.objDescription }}</div>
				<div> {{ getClientName(item) }}</div>
				<div>Stunden: {{ item.hours }}</div>
			</div>
			<div *ngIf="item.notes" class="note">
				<fa-icon (click)="showNotes($event, item)" [icon]="faExclamationCircle" [ngStyle]="getIconStyle(2)"></fa-icon>
			</div>
		</div>
	</div>
</main>
<footer class="timeapp">
	<mat-icon (click)="goBack()" class="icon-size"> arrow_back</mat-icon>
</footer>
